module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.album) ? _c('div', {
    staticClass: "SmugmugAlbumThumbnail",
    class: _vm.classes
  }, [_c(_vm.route ? 'router-link' : 'div', {
    tag: "component",
    style: (_vm.SmugmugAlbumThumbnailLinkStyle),
    attrs: {
      "to": _vm.route
    }
  }, [_c('thumbnail', {
    staticClass: "SmugmugAlbumThumbnail-image",
    attrs: {
      "image": _vm.resolvedImage,
      "tags": _vm.tags,
      "button": _vm.button,
      "ratio": _vm.ratio
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-481c33c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmugmugAlbumThumbnail.vue
// module id = 763
// module chunks = 1474